import styles from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/AgentAiDiscoveryDrawer.module.scss"
import { TABS } from "@/organisms/Drawers/components/AgentAiDiscoveryDrawer/const"
import { TabsDrawerTemplate } from "@/organisms/Drawers/components/TabsDrawerTemplate"
import { WIDTH_DEFAULT } from "@/organisms/Drawers/const"
import { AiComponentsTabWorkflowAiDiscoveryDrawer } from "./AiComponentsTabWorkflowAiDiscoveryDrawer"
import { OverviewTabWorkflowAiDiscoveryDrawer } from "./OverviewTabWorkflowAiDiscoveryDrawer"
import { RiskTabWorkflowAiDiscoveryDrawer } from "./RiskTabWorkflowAiDiscoveryDrawer"
import { TitleWorkflowAiDiscoveryDrawer } from "./TitleWorkflowAiDiscoveryDrawer"

import type { TabsDrawerTemplateProps } from "@/organisms/Drawers/components/TabsDrawerTemplate"

const TABS_WORKFLOW = [TABS.overview, TABS.aiComponents, TABS.aiRisks]
const COMPONENTS_WORKFLOW = [
  OverviewTabWorkflowAiDiscoveryDrawer,
  AiComponentsTabWorkflowAiDiscoveryDrawer,
  RiskTabWorkflowAiDiscoveryDrawer
]

export const WorkflowAiDiscoveryDrawer = (
  props: Omit<TabsDrawerTemplateProps, "name" | "tabs" | "components"> & {
    widthAdditive: number
  }
) => {
  const { widthAdditive, ...restProps } = props

  return (
    <TabsDrawerTemplate
      classes={{ drawer: styles.drawer }}
      name="WorkflowAiDiscoveryDrawer"
      tabs={TABS_WORKFLOW}
      components={COMPONENTS_WORKFLOW}
      Title={TitleWorkflowAiDiscoveryDrawer}
      width={WIDTH_DEFAULT + widthAdditive}
      {...restProps}
    />
  )
}
